// KD-3626 — builds the `extras` array sent by the Requirements save.
//
// The API treats the body as the full truth for every extra it contains
// (delete + reinsert of the recommendation pairs), and the session only knows
// the programs its searches have loaded: everything else must be carried over
// from the server state, otherwise saving while filtered by starting/ending
// point silently wipes the requirements of every program outside the filter.
//
// Rule per (extra, program) pair:
// - program loaded in the session -> the session's selection is authoritative
//   (its additions and removals are applied);
// - program never loaded -> the server pair is preserved untouched.
export function buildExtrasPayload(
  serverExtras = [],
  sessionRows = [],
  incompatibleIds = [],
) {
  const incompatible = new Set(incompatibleIds);
  const rows = (sessionRows ?? []).filter((row) => !incompatible.has(row.id));
  const sessionRowIds = new Set(rows.map((row) => row.id));

  const selectedByExtra = new Map();
  for (const row of rows) {
    for (const option of row.recommendations ?? []) {
      const extraId = option.value ?? option.id;
      if (!selectedByExtra.has(extraId)) {
        selectedByExtra.set(extraId, []);
      }
      selectedByExtra.get(extraId).push({ id: row.id, name: row.name });
    }
  }

  return (serverExtras ?? []).map((extra) => {
    const preserved = (extra.recommendations ?? [])
      .filter((recommendation) => !sessionRowIds.has(recommendation.id))
      .map(({ id, name }) => ({ id, name }));

    return {
      ...extra,
      recommendations: [...(selectedByExtra.get(extra.id) ?? []), ...preserved],
    };
  });
}
